import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';

@Component({
  selector: 'etxe-property-draft-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, DialogLayoutAuraComponent],
  template: `
    <aura-dialog-layout [title]="'Vous avez déjà un brouillon en cours'" [hideCancel]="true">
      <div dialog-content>
        <p class="text-gray-11">Vous pouvez le compléter ou le supprimer pour créer une nouvelle annonce</p>
      </div>

      <div dialog-actions class="flex w-full gap-3">
        <button mat-stroked-button class="flex-1" (click)="onDelete()">Supprimer le brouillon</button>
        <button mat-flat-button class="primary flex-1" (click)="onContinue()">Continuer le brouillon</button>
      </div>
    </aura-dialog-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDraftDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<PropertyDraftDialogComponent>);

  onDelete() {
    this.dialogRef.close('delete');
  }

  onContinue() {
    this.dialogRef.close('continue');
  }
}
